import { ReactElement, ReactNode, isValidElement } from 'react'
import classNames from 'classnames/bind'
import { path } from 'ramda'

import PlainLink from 'app/common/ui-next/plain-link'

import IconChild from './icons/IconChild'
import * as c from './constants'
import styles from './side-navigation-item.module.scss';


const cx = classNames.bind(styles)

export type Props = {
  children?: ReactNode,
  title: string,
  to: string,
  active?: boolean,
  collapsed?: boolean,
  hideIcon?: boolean,
  disabled?: boolean,
}

export const SideNavigationItem = ({
  children,
  title,
  to,
  active,
  collapsed,
  hideIcon,
  disabled,
}: Props) => (
  <PlainLink
    className={cx(styles.root, { active, disabled }, c.ITEM_CLASS_NAME)}
    disabled={disabled}
    to={to}
  >
    {!hideIcon && <div className={styles.icon}>
      {children || <IconChild />}
    </div>}

    <div className={cx(styles.title, { collapsed })}>
      {title}
    </div>
  </PlainLink>
)


SideNavigationItem.displayName = 'SideNavigationItem'

export const isSideNavigationItem = (
  comp: ReactNode,
): comp is ReactElement<Props, typeof SideNavigationItem> => {
  const displayName = path(['type', 'displayName'], comp)
  return isValidElement(comp) && displayName === 'SideNavigationItem'
}
